import { ChartDrawOption } from '@/modules/ta/widget/models/drawoptions/ChartDrawOption';
import { isNil } from 'lodash';
import { BulletShapes } from '@/modules/core/charts/am5/charts.constants';
import { GradientTypes } from '@/modules/ta/widget/builder.constants';
import { DateFormatType } from '@/modules/ta/widget/widget.constants';

export class BubbleChartDrawOption extends ChartDrawOption {
  /**
   * @var {number}
   */
  width;

  /**
   * @var {number}
   */
  bubble_max_bubbles;

  /**
   * @var {number}
   */
  rounded_corners;

  /**
   * @var {string}
   */
  background_gradient;

  /**
   * @var {string}
   */
  gradient_color;

  /**
   * @var {string}
   */
  bubble_shape;

  /**
   * @var {boolean}
   */
  show_values_on_shapes;

  /**
   * @var {number}
   */
  shape_opacity;

  /**
   * @var {boolean}
   */
  show_shape_shadow;

  /**
   * @var {number}
   */
  shape_size;

  constructor(model = {}) {
    super(model);

    this.width = model.width ?? 80;
    this.rounded_corners = model.rounded_corners ?? 0;
    this.bubble_max_bubbles = isNil(model.bubble_max_bubbles) ? 100 : model.bubble_max_bubbles;
    this.date_format_type = model.date_format_type || DateFormatType.NO_YEAR;
    this.background_gradient = isNil(model.background_gradient)
      ? GradientTypes.SOLID
      : model.background_gradient;
    this.gradient_color = isNil(model.gradient_color) ? '#777777' : model.gradient_color;
    this.bubble_shape = isNil(model.bubble_shape) ? BulletShapes.CIRCLE : model.bubble_shape;
    this.show_values_on_shapes = isNil(model.show_values_on_shapes)
      ? false
      : model.show_values_on_shapes;
    this.shape_opacity = isNil(model.shape_opacity) ? 70 : model.shape_opacity;
    this.show_shape_shadow = isNil(model.show_shape_shadow) ? false : model.show_shape_shadow;
    this.shape_size = isNil(model.shape_size) ? 50 : model.shape_size;
  }
}
